import { render, staticRenderFns } from "./BaseSendForm.vue?vue&type=template&id=1b052d71&scoped=true&"
import script from "./BaseSendForm.vue?vue&type=script&lang=js&"
export * from "./BaseSendForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseSendForm.vue?vue&type=style&index=0&id=1b052d71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b052d71",
  null
  
)

export default component.exports